import {addUserId} from "../../store.js";
import {SignUpViewChanger} from "../../util/view-changer/index.js";
import {SignUpComponent} from "../SignUpComponent.js";



export class SnSButton extends SignUpComponent {

    render() {
        const {isRender = true} = this.$props;
        if(!isRender) {
            return;
        }
        super.render();
    }
    template() {
        const {type = "a"} =  this.$props;
        const {id ='', className ='', buttonText = '', snsType = "SNS" } =  this.getButtonDataJson();
        if(type === "a") {
            return `<a id="${id}" class ="${className} cursor-pointer js-sns-signup-btn"><em></em><span>${buttonText}</span></a>`;
        }
        return `<button id="${id}" class="${className}  start-${snsType.toLowerCase()}-button cursor-pointer js-sns-signup-btn"><em></em><span>${buttonText}</span></button>`
    }

    getButtonDataJson() {
        return  {
            snsType : "",
            id : "",
            className : ``,
            buttonText : "SNS 회원 가입 계정으로 시작하기"
        }
    }

    setEvent() {
        const buttonId = this.getButtonDataJson().id;
        this.addEvent("click.prevent", `#${buttonId}`, (e) => {
            addUserId("SNS 아이디");
            SignUpViewChanger.loadProfileView()
        });
    }
}
